import {
  ActionAddMinerChangeLog,
  ActionClearMinerChangeLogs,
  ActionSetMinerChangeLogs,
  ActionTypesMinerChangeLogs,
  IMinerLog,
} from "./actionsTypes";

export const setMinerChangeLogs = (
  payload: IMinerLog[]
): ActionSetMinerChangeLogs => {
  return {
    type: ActionTypesMinerChangeLogs.SET_MINER_LOGS,
    payload,
  };
};

export const clearMinerChangeLogs = (): ActionClearMinerChangeLogs => {
  return {
    type: ActionTypesMinerChangeLogs.CLEAR_MINER_LOGS,
  };
};

export const addMinerChangeLogs = (
  payload: IMinerLog
): ActionAddMinerChangeLog => {
  return {
    type: ActionTypesMinerChangeLogs.ADD_MINER_LOG,
    payload,
  };
};
